import { t } from "i18next";
import _ from "lodash";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import ErrorsBlock from "../../../components/errors/ErrorsBlock";
import { useFetch } from "../../../hooks/useFetch";
import { DowntimesType } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";

const AddDowntime = () => {
  const [downtimes, setDowntimes] =
    useOutletContext<[DowntimesType[], Function]>();

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
      description: "",
    },
  });

  const [
    { response: saveResponse, isLoading: saveIsLoading, error: saveError },
    doFetchItemSave,
  ] = useFetch(`/administration/directories/downtime_reasons`, true);

  const onSubmit = (formData: any) => {
    setErrors([]);
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          description: formData.description,
        },
      },
    });
  };

  const AddDowntime = (itemSaveResponse: { data: unknown }) => {
    const newDowntimeData = itemSaveResponse as unknown as DowntimesType;
    setDowntimes(
      downtimes.length > 0
        ? [...downtimes, newDowntimeData]
        : [newDowntimeData],
    );
  };

  useEffect(() => {
    if (!saveResponse) return;
    AddDowntime(saveResponse);
    reset();
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
    console.log(saveError);
  }, [saveError]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden my-[4rem]">
        <div className="text-xl font-semibold">
          {t("adding_downtime_reason")}
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col w-full pt-8 h-full gap-3">
            {errors ? <ErrorsBlock errors={errors} /> : ""}
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("title_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="description"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("description")}*`} />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddDowntime;
